const menuConfig = [
  {
    title: 'Home',
    path: '/'
  },
  {
    title: 'About us',
    path: '/about-us'
  },
  {
    title: 'Available Courts',
    path: '/services'
  },
];

export default menuConfig;
